export default __webpack_public_path__ + "static/media/4.1d754de8.jpg";